'use strict';

var GridExportDirective = function GridExportDirective() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: require('../templates/grid-export.html'),
    controller: 'GridExportController',
    scope: {
      gridSettings: '=',
      gridId: '@',
      postExportDataTransformer: '=?'
    }
  };
};
GridExportDirective.$inject = [];
module.exports = GridExportDirective;